import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-shimmer-list',
  templateUrl: './shimmer-list.component.html',
  styleUrl: './shimmer-list.component.css',
})
export class ShimmerListComponent implements OnInit {
  @Input() count: number = 5;
  ngOnInit(): void {}
}
